import { __awaiter, __generator } from "tslib";
import { createBindingApi } from '../../api/create-binding';
import { fixDomainSfx, getDomainSfx } from '../../utils/common';
import { paymentForm } from '../payment-form';
import { getCreateBindingParams } from './utils';
export var bindCard = function (apiHost, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryParams = options.queryParams;
                    url = options.url;
                    if (url) {
                        return [2, paymentForm(apiHost, { url: url, queryParams: queryParams })];
                    }
                    return [4, createBindingApi(apiHost, getCreateBindingParams(options))];
                case 1:
                    url = _a.sent();
                    url = fixDomainSfx(url, getDomainSfx());
                    return [2, paymentForm(apiHost, { url: url, queryParams: queryParams })];
            }
        });
    });
};
